/**
 * myDraft CMS — User Entry Point
 *
 * Main bundle for public-facing pages. Loads context-dependent modules
 * via the bootstrap system. Intended to replace jquery_user_main.js.
 *
 * Usage in Smarty templates:
 *   <script type="module" src="{{ asset_url('assets/js/user.bundle.js') }}"></script>
 *
 * @package MyDraft\Frontend
 * @version 1.0.0
 */

import { bootstrapModules } from '../core/bootstrap';

// Auto-bootstrap on import (module execution)
bootstrapModules().catch((err) => {
  console.error('[myDraft] Bootstrap failed:', err);
});